import React, { Component } from 'react';
import { connect } from 'react-redux';
import './BuildingAdd.css';
import Tabbar from '../../../Components/Tabbar/Tabbar';
import { Link, Redirect } from 'react-router-dom';
import { addBuilding, clearErrs } from '../../../Store/Actions/RestActions';
import { TimePicker } from '@progress/kendo-dateinputs-react-wrapper';
import ErrorModal from '../../../Components/errorModal';

class AddBuildingPage extends Component {

	constructor(props) {
		super(props);
		this.state = {
			name: '',
			abbreviation: '',
			description: '',
			open: '',
			closed: '',
		};
		this.handleInputChange = this.handleInputChange.bind(this);
		this.handleSubmit = this.handleSubmit.bind(this);
	}

	handleInputChange(event) {
		const target = event.target;
		const value = target.type === 'checkbox' ? target.checked : target.value;
		const name = target.name;

		this.setState({
			[name]: value,
		});
	}

	handleSubmit(event) {
		event.preventDefault();
		this.props.addBuilding({ name: this.state.name, abbreviation: this.state.abbreviation, description: this.state.description, open: this.state.open, closed: this.state.closed });
	}

	componentDidMount() {
		this.props.clearError();
	}

	render() {
		if (this.props.fireRedirect) {
			return (
				<Redirect to="/buildings" />
			);
		}
		return (
			<div className="container">
				<Tabbar setActiveTab="buildings" />
				<div className="contentBox tabbed-content-box addBuilding">
					<form onSubmit={this.handleSubmit}>
						<h3>Add Building</h3>
						<Link className="addCancel" to="/buildings">X</Link>
						<div className="ResourceAddLeft">
							<div className="inputGroup">
								<label className="">Name:</label>
								<input
									className="addBldgInput"
									type="text"
									placeholder="Enter Building Name"
									name="name"
									defaultValue={this.state.name}
									onChange={this.handleInputChange} />
							</div>
							<div className="inputGroup">
								<label className="">Abbreviation:</label>
								<input
									className="addBldgInput"
									type="text"
									placeholder="Enter Building Abbreviation"
									name="abbreviation"
									defaultValue={this.state.abbreviation}
									onChange={this.handleInputChange} />
							</div>
							<div className="inputGroup">
								<label className="">Description:</label>
								<input
									className="addBldgInput"
									type="text"
									placeholder="Enter description here"
									name="description"
									defaultValue={this.state.description}
									onChange={this.handleInputChange} />
							</div>
							<div className="timeInputGroup">
								<label className="timeInputLabel"> Open Time:</label>
								<TimePicker
									value={this.state.open}
									name="open"
									// change={this.handleInputChange}
									change={(e) => { this.setState({ open: e.sender.value() }); }}
								/>
							</div>
							<div className="timeInputGroup right">
								<label className="timeInputLabel"> Close Time:</label>
								<TimePicker
									value={this.state.closed}
									name="closed"
									// change={this.handleInputChange}
									change={(e) => { this.setState({ closed: e.sender.value() }); }}
								/>
							</div>
						</div>
						<div className="formControls">
							<input className="addSubmit" type="submit" value="Add Building" />
						</div>
					</form>
				</div>
				<ErrorModal error={this.props.error} errMsg={this.props.errMsg} formError={this.props.formError} onClose={this.props.clearError}></ErrorModal>

			</div>

		);
	}
}
const mapStateToProps = state => ({
	schedule: state.schedulePage,
	roomTypes: state.roomTypes.data,
	resources: state.assets.data,
	buildings: state.buildings.data,
	floors: state.floors.data,
	rooms: state.rooms.data,
	error: state.buildings.hasError,
	errMsg: state.buildings.errMsg,
	fireRedirect: state.buildings.redirect
});

const mapDispatchtoProps = dispatch => ({
	addBuilding: data => dispatch(addBuilding(data)),
	clearError: () => dispatch(clearErrs('buildings'))

});

export default connect(mapStateToProps, mapDispatchtoProps)(AddBuildingPage);



// WEBPACK FOOTER //
// ./src/Pages/Buildings/BuildingAdd/BuildingAdd.js